<script>
	/**
	 * 경고·안내 상자. [레시피] 탭 공용.
	 * ⚠️ 예전엔 경고가 회색 설명문 사이에 빨간 **글자**로만 섞여 있어, 설명문 더미에 묻혀 안 보였다.
	 *    상자로 떼어 낸다 — 'error' 는 그대로 두면 깨지는 것, 'warn' 은 알고 써야 하는 것, 'info' 는 참고.
	 */
	export let variant = "info";
</script>

<div class="callout {variant}"><slot /></div>

<style>
	.callout {
		border-radius: 8px;
		border-left: 3px solid;
		padding: 8px 10px;
		font-size: 12px;
		line-height: 1.5;
	}
	.info {
		border-color: hsl(var(--sb-border));
		background: hsl(var(--sb-muted));
		color: hsl(var(--sb-muted-foreground));
	}
	.warn {
		border-color: #f59e0b;
		background: rgba(245, 158, 11, 0.1);
		color: #92400e;
	}
	.error {
		border-color: hsl(var(--sb-destructive));
		background: hsl(var(--sb-destructive) / 0.08);
		color: hsl(var(--sb-destructive));
	}
	:global(.dark) .warn {
		color: #fbbf24;
	}
</style>
